<template>
  <b-card no-body>
    <b-card-header>
      <slot />
      {{ title }}<br><small>{{ url }}</small>
    </b-card-header>
    <b-card-body>
      {{ isArray(form.group) }}
      <b-button 
        v-if="!isArray(form.group)" 
        @click="$set(form,'group',[])"
      >
        Init array
      </b-button>
      <b-form-row 
        v-for="(g,index1) in form.group" 
        :key="index1"
      >
        <b-col 
          v-for="(subitem,index2) in g.item" 
          v-if="isArray(g.item)" 
          :key="index2"
        >
          <b-form-group :label="`Rij ${index1+1} veld ${index2+1}`">
            <b-input-group>
              <b-form-input
                v-model="subitem['#text']"
                placeholder="Omschrijving"
              />
            
              <b-form-input 
                v-model="subitem['-id']" 
                placeholder="CODE"
              />
            </b-input-group>
            <b-form-input v-model="subitem['-suggest']" />
          </b-form-group>
        </b-col>
        <b-col v-else>
          <b-form-group :label="g.item['#text']" />
          {{ g.item }}
          <b-button @click="form.group.splice(form.group.indexOf(g),1)">
            delete
          </b-button>
        </b-col>
        <b-button 
          v-if="editMode" 
          class="my-3" 
          variant="outline-secondary" 
          @click="g.item.push({ '-id': 'TEST', '#text': 'test' } )"
        >
          +
        </b-button>
      </b-form-row>
      <b-button 
        v-if="editMode" 
        class="my-3" 
        variant="outline-secondary" 
        @click="form.group.push({ 'item': [{ '-id': 'LCA', '#text': 'test' }]})"
      >
        + Nieuwe rij beginnen
      </b-button>
    </b-card-body>
    <b-card-footer>
      <b-button 
        variant="success" 
        @click="opslaanElement"
      >
        Opslaan
      </b-button>
      {{ boodschap }}
      <small>{{ url }}</small>
    </b-card-footer>
  </b-card>
</template>
<script>
import { elementenMixin } from "@/mixins/elementenMixin";
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
  name: "ElementEditCard",
  mixins: [elementenMixin,serviceMixin],
  props: {
    title: { type: String },
    form: { type: Object },
    code: {type: String }
  },
  data() {
    return {
      isBusy: false,
      boodschap: "...",
      editMode: true
    };
  },
  computed: {
    url: function() {
      return `/element/${this.code.replaceAll('.','_')}`
    }
  },
  methods: {
    deleteElement(group,object) {
      this.$delete(group,object);
    },
    isArray(obj) {
      return Array.isArray(obj);
    },
    opslaanElement() {
      var vm = this;
      // opslaan formulier
      this.put(this.url,{ formData: this.form})
      .then(function(response) {
        console.dir(response.data);
        vm.form = response.data.element;
        vm.boodschap = response.data.resultaat;
      })
      .catch(function(error) {
        console.log(error);
      });
    }
  }
};
</script>